import React, { useRef } from 'react';
import { IonItem, IonLabel, IonModal, IonRow } from '@ionic/react';
import AppTypeahead from '../job-details/job-details-update/AppTypehead';

export class AutocompleteSelectItem {
  readonly id: string;
  readonly text: string;
  readonly isNewItem: boolean = false;

  constructor(id: string, text: string, isNewItem: boolean = false) {
    this.id = id;
    this.text = text;
    this.isNewItem = isNewItem;
  }
}

interface AutocompleteSelectProps {
  value: string;
  options: AutocompleteSelectItem[];
  label: string;
  searchModalTitle: string;
  searchBarPlaceholder?: string;
  onItemSelected: (item: AutocompleteSelectItem) => void;
}

export const AutocompleteSelect: React.FC<AutocompleteSelectProps> = props => {
  const modal = useRef<HTMLIonModalElement>(null);
  const dismissModal = () => {
    modal.current?.dismiss();
  };

  const onItemSelected = (item: AutocompleteSelectItem) => {
    props.onItemSelected(item);
    dismissModal();
  };

  return (
    <>
      <IonRow className="custom-input-label-row">
        <IonLabel className="custom-input-label" mode="md">
          {props.label}
        </IonLabel>
      </IonRow>
      <IonItem className={'outlined-input-item'} lines="none" button={true} detail={false} id="select-item">
        <div id="selected-item">{props.value}</div>
      </IonItem>

      <IonModal trigger="select-item" ref={modal}>
        <AppTypeahead
          title={props.searchModalTitle}
          placeholder={props.searchBarPlaceholder}
          items={props.options}
          onItemSelected={onItemSelected}
          onClose={dismissModal}
        />
      </IonModal>
    </>
  );
};
